import type { PlayerSources, ProgressiveSources } from './player.config';

import { AutoQualityId } from '../settings-menu/settings-menu.types';

export function getInitialQualityId(sources: PlayerSources, src: string) {
  if (sources.hls) {
    return AutoQualityId;
  }

  const currentSource = src;
  if (currentSource !== undefined && sources.progressive) {
    const quality = findQualityForCurrentSource(currentSource, sources.progressive);
    if (quality) {
      return quality;
    }
  }
}

function findQualityForCurrentSource(currentSource: string, progressiveSources: ProgressiveSources) {
  return Object.keys(progressiveSources).find((quality) => {
    const sourceObject = progressiveSources[quality];
    return sourceObject.find((source) => source.src === currentSource) !== undefined;
  });
}
